import * as React from "react";
import { api, user } from "src/services/api";
import { routeApi } from "src/services/browser";
import { Formatters, Modal } from "src/components/ui";

interface Props {
    id: any;
    item: any;
    onClose: Function;
}
interface State {
}
export class DocenteListino extends React.Component<Props, State> {
    constructor(props) {
        super(props);
        this.state = {
        };
    }
    
    cancel() {
        const { onClose } = this.props;
        if (onClose) {
            onClose();
        }
    }
  
    render() {
        const { children, id, item } = this.props;
        const { } = this.state;

        const materie = item.extra.materie.map( (i) => (i.nome) ).join(', ');
        const tipi_tariffe = ['elementari', 'medie', 'superiori', 'universita', 'altre_tipologie'];
        const labels_tariffe = [ 'Livello elementari', 'Livello Medie', 'Livello Superiori', 'Livello Università', 'Altre tipologie'];
        
        return (
            <Modal
              open={true}
              backdrop={true}
              icon={item.thumb ? null : "user"}
              iconImg={item.thumb || null}
              className="docente_Listino ecommerce_AcquistiScuola_bigheader"
              onClose={() => this.cancel()}
            >
              <header>
                <h2>{item.nome} {item.cognome.substr(0, 1)}.</h2>
              </header>
              <section>
                <h3>Materie insegnate</h3>
                <p>{materie}</p>
              </section>
              <section>
                <h3>Tariffe <span>*</span></h3>
                {tipi_tariffe.map( (t,i) => (
                    <article key={i}>
                        <div>{labels_tariffe[i]}</div>
                        {item.extra[`tariffa_${t}`] > 0 &&
                        <div>
                            €/h
                            <span>{Formatters.Price({val: item.extra[`tariffa_${t}`], currency: ''}) }</span>
                        </div>
                        }
                    </article>
                ))}
              </section>
              <footer>
                <span>*</span> Le tariffe sopraelencate sono indicative. Non costituiscono vincolo contrattuale, e sono da confermare nel diretto contatto tra le parti.
              </footer>
            </Modal>
        );
    }
}

interface StateToggler {
    item?: any;
    open: "modal" | null;
}
export default class DocenteListinoToggler extends React.Component<any, StateToggler> {
    constructor(props) {
        super(props);
        this.state = {
            open: null
        };
    }
    
    async execute() {
        const item = await api({
            url: routeApi('docente.show', { docente: this.props.id }),
            method: 'get'
        });
        this.setState({item, open: "modal"});
    }
    
    render() {
        const { open = null, item } = this.state;
        const props = {
            ...this.props,
            item,
            onClose: () => this.setState({open: null})
        } as any;
        return (
        <>
            {open === "modal" &&
            <DocenteListino {...props} />
            }
            <span onClick={() => this.execute() }>
                {this.props.children}
            </span>
        </>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/docente/Listino.tsx